import { createContext, useContext, useEffect, useState } from "react";
import { http } from "../lib/api";

const SiteContext = createContext({ settings: null, products: [] });

export const SiteProvider = ({ children }) => {
  const [settings, setSettings] = useState(null);
  const [products, setProducts] = useState([]);

  useEffect(() => {
    http.get("/content/settings").then((r) => setSettings(r.data)).catch(() => {});
    http.get("/content/products").then((r) => setProducts(r.data)).catch(() => {});
  }, []);

  return (
    <SiteContext.Provider value={{ settings, products }}>
      {children}
    </SiteContext.Provider>
  );
};

export const useSite = () => useContext(SiteContext);

export const whatsappLink = (settings, text = "Hello MAKO, I would like to discuss mats for my facility.") => {
  const number = (settings?.contact?.whatsapp || "+910000000000").replace(/[^\d]/g, "");
  return `https://wa.me/${number}?text=${encodeURIComponent(text)}`;
};
